import axios from 'axios';
import { showLoading, hideLoading } from './loading';

const URL = "/api";

const api = axios.create({
    baseURL: URL,
    withCredentials: true,
    headers: {
        'Accept': '*/*',
    },
});

// Interceptor de requisição
api.interceptors.request.use((config) => {
    const session = JSON.parse(localStorage.getItem("session"));
    if (session?.token) {
        config.headers['Authorization'] = 'Bearer ' + session.token;
    }

    showLoading(); // <- mostra loading
    return config;
}, (error) => {
    hideLoading(); // <- oculta loading em erro de envio
    return Promise.reject(error);
});

// Interceptor de resposta
api.interceptors.response.use((response) => {
    hideLoading(); // <- oculta loading
    return response;
}, (error) => {
    hideLoading(); // <- oculta loading mesmo com erro
    return Promise.reject(error);
});

export default api;
